export default __webpack_public_path__ + "static/media/Header-Avatar.b9405777.png";